import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, FormControl, Container } from "react-bootstrap";
import { getLMSEnrollments, selectUser, selectUsers } from "../../Redux/Actions/enrollmentsAction";
import "bootstrap/dist/css/bootstrap.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Loader } from "semantic-ui-react";
import DoceboRosterTable from "../components/doceboRosterTable";
//import UserInfoModal from "../components/userInfoModal";
import UserInfoModal from "../components/usersModal";
import './../../config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../components/CommonModal/manage-roster-modal.css";
import "./manage-course-container.css";
import ManageRosterPageHeader from "../components/ManageRosterPageHeader";
import CourseDetailsScrollStrip from "../components/CourseDetailsScrollStrip";
import CommonModal from "../../components/CommonModal";

// DOCEBO
const ManageRoster = () => {
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [usersInfo, setUsersInfo] = useState([]);

  const [enrollmentsLoading, setEnrollmentsLoading] = useState(true);
  const [usersLoading, setUsersLoading] = useState(false);
  
  const [courseId, setCourseId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [eventId, setEventId] = useState("");

  const [courseName, setCourseName] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [eventName, setEventName] = useState("");

  //let baseApiUrl = "http://rlddocebo.localhost:8080/v1";
  let baseApiUrl = global.config.baseApiUrl;
  
  const { course: currentCourse, session: currentSession, event: currentEvent } = useSelector(state => state.courses);
  const { user: currentUser } = useSelector(state => state.auth);
  const { user: selectedUser } = useSelector(state => state.enrollments);
  
  const dispatch = useDispatch(); 

  const [show, setShow] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
    console.log('username: ' + JSON.stringify(username));
  };

  const onChangeName = (e) => {
    const name = e.target.value;
    setName(name);
    console.log('name: ' + JSON.stringify(name));
  };

  const handleClose = () => {
    console.log("Clicked handleClose()********");
    setDisabled(true);
    dispatch(selectUser({}));
    setName("");
    setUsername("");
    setShow(false);
  };

  //const handleClose = () => setShow(false);
  
  // set isMounted to false when we unmount the component
  //useEffect(() => {
  //  return () => {
  //    isMounted.current = false
  //  }
  //}, [])

  const handleShow = () => {
      dispatch(selectUser([]));
      setUsersInfo([]);
      // send the actual request
      let url = baseApiUrl + "/people";
      console.log('handleShow: url: ' + url);

      setUsersLoading(true);
      if (username == null || username === '') {
        setUserInfo({});
        //setUsersInfo([]);
        setUsersLoading(false);
        setShow(true);
      } else {
        // momentive badge logic
        let companyId = global.config.companyId;
        let username_modified = username;
        console.log('The username is: ' + JSON.stringify(username_modified));
        
        if (companyId.includes('momentive')) {
          let regExp = /[a-z]/i;
          if(regExp.test(username_modified)){
            // if alphabets, get the prefix chars based on middle split
	          let half = Math.floor(username_modified.length / 2);
	          username_modified = username_modified.slice(0, half);
          } else {
            // if numeric, get the last 5 digits
            username_modified = username_modified.slice(-5);
          }
        }

        let reqBody = {userId: username_modified,
                       accessToken: currentUser.accessToken};

        console.log('The handleShow UserId is: ' + JSON.stringify(username_modified));

        axios.post(url, reqBody).then(
          (response) => {
            console.log("course-session-event handleShow: " + response);
            //dispatch(selectUser(username));
            console.log(
              "user info is: " + JSON.stringify(response.data.userInfo)
            );
            console.log("users is: " + JSON.stringify(response.data.users));
  
            if (response.data.userInfo && JSON.stringify(response.data.userInfo[0]) != '{}') {
              setUsersInfo(response.data.userInfo);
              dispatch(selectUser(response.data.userInfo));
            } else if (response.data.users) {
              setUsersInfo(response.data.users);
              dispatch(selectUser(response.data.users));
            } else {
              setUsersInfo([]);
            }
            setDisabled(true);
            setUsersLoading(false);
            setShow(true);
          },
          (error) => {
            dispatch(selectUsers([]));
            setDisabled(true);
            setUsersInfo([]);
            setUsersLoading(false);
            console.log(error);
          }
        );
      }
  }; // update the callback if the state changes

  const handleSearchUsers = () => {
    // send the actual request
    let url = baseApiUrl + "/people";
    console.log('getDoceboUserInfo: url: ' + url);

    setUsersLoading(true);
    if (name == null || name === '') {
      setUsersInfo([]);
      setUsersLoading(false);
      setShow(true);
    } else {
      let reqBody = {"search_text": name,
                     "accessToken": currentUser.accessToken};
      console.log('The search_text is: ' + JSON.stringify(name));

      axios.post(url, reqBody).then((response) => {
        console.log("People Search Response:" + JSON.stringify(response.data.users));
        //dispatch(selectUser(response.data.users));
        console.log("users info is: " + JSON.stringify(response.data.users));
        console.log("selectedUser is " + selectedUser);
        dispatch(selectUsers(response.data.users));
        setDisabled(true);
        setUsersInfo(response.data.users);

        setUsersLoading(false);
        setShow(true);
      }, (error) => {
        dispatch(selectUsers([]));
          setDisabled(true);
          setUsersInfo([]);
          setUsersLoading(false);
          console.log(error);
      });

      setShow(true);
    }
} // update the callback if the state changes

  const onUserInfoFormSubmit = (e) => {
    e.preventDefault();
    handleClose();
    handleSubmit();
  };

  function handleSubmit(e) {
    setEnrollmentsLoading(true);
    console.log("Inside handleSubmit: " + JSON.stringify(selectedUser));
    var failed = false;
    //e.preventDefault();
    // Set the UserId in the Redux
    // Check-In Learner | Mark Attendance | Completion | Walk-In Learner
    // Check Learner if in DB, also check the enrollment listings
    // Walk-In, 
    // Check-In
    // Mark Attendance
    // Mark Completion

    // send the actual request
    let url = baseApiUrl + "/learner/check";
    console.log('getDoceboLearnerCheck: url: ' + url);

    if (!username) {
      setUsername(selectedUser);
    }

    let course_id = currentCourse.course_id;
    let session_id = currentSession.session_id;
    let event_id = currentEvent.event_id;

    setCourseId(course_id);
    setSessionId(session_id);
    setEventId(event_id);

    setCourseName(currentCourse.course_name);
    setSessionName(currentSession.session_name);
    setEventName(currentEvent.event_name);

    let reqBody = {"courseId": course_id,
                     "sessionId": session_id,
                     "eventId": event_id,
                     "accessToken": currentUser.accessToken,
                     "learners": [
                      selectedUser
                  ]};
    
    handleClose();
    axios.post(url, reqBody).then(data => {
      console.log('handleSubmit:getLMSEnrollments:data: ' + JSON.stringify(data));

      if (data) {
        console.log('onUserInfoFormSubmit: data: ' + JSON.stringify(data.data.enrollments) + ' - ' + JSON.stringify(data.data.enrollments.length));
        if (data.data.enrollments && data.data.enrollments.length > 0) {
          console.log('onUserInfoFormSubmit: data.enrollments.size(): ' + data.data.enrollments.length + ' selectedUser: ' + selectedUser);
          var userObj = data.data.enrollments.find(x => x.id === selectedUser);
          console.log('onUserInfoFormSubmit: userObj: ' + JSON.stringify(userObj));
          if (userObj) {
            if (userObj.completed === "1") {
              toast.warn(userObj.name + " has already been marked Complete.", {
                position: toast.POSITION.BOTTOM_CENTER
              });
            } else {
              toast.info(userObj.name + " has been successfully Enrolled.", {
                position: toast.POSITION.TOP_CENTER
              });
            }
          } else {
            console.log('onUserInfoFormSubmit: DELAY');
          }
        }
        dispatch(getLMSEnrollments(data, failed));
      } 

      setEnrollmentsLoading(false);
    });
    
  }

  useEffect(() => {
    console.log("currentCourse", currentCourse)
    if (currentCourse) {
      setCourseId(currentCourse.course_id);
      setCourseName(currentCourse.course_name);
    }
  }, [currentCourse]);

  useEffect(() => {
    console.log("currentSession", currentSession)
    if (currentSession) {
      setSessionId(currentSession.session_id);
      setSessionName(currentSession.session_name);
    }
  }, [currentSession]);

  useEffect(() => {
    console.log("currentEvent", currentEvent)
    if (currentEvent) {
      setEventId(currentEvent.event_id);
      setEventName(currentEvent.event_name);
    }
  }, [currentEvent]);

  useEffect(() => {
    if (selectedUser) {
      setDisabled(false);
    }
  }, [selectedUser]);

  // Get Enrollment Listings
  useEffect(() => {
    let unmounted = false;

    async function getDoceboEnrollments() {
      var failed = false;
      setEnrollmentsLoading(true);

      let url = baseApiUrl + "/enrollments";
      console.log('getDoceboEnrollmentListings: url: ' + url);

      let course_id = '';
      let session_id = '';
      let event_id = '';

      let course_name = '';
      let session_name = '';
      let event_name = '';

      if (currentCourse) {
        course_id = currentCourse.course_id;
        session_id = currentSession.session_id;
        event_id = currentEvent.event_id;
        course_name = currentCourse.course_name;
        session_name = currentSession.session_name;
        event_name = currentEvent.event_name;
      }

      setCourseId(course_id);
      setSessionId(session_id);
      setEventId(event_id);

      setCourseName(course_name);
      setSessionName(session_name);
      setEventName(event_name);

      let reqBody = {"courseId": course_id,
                     "sessionId": session_id,
                     "eventId": event_id,
                     "accessToken": currentUser.accessToken};

      console.log('The Enrollment Listings reqBody: ' + JSON.stringify(reqBody));
      let data = await axios.post(url, reqBody);
      console.log('The Enrollments are: ' + JSON.stringify(data));
      if (data) {
        dispatch(getLMSEnrollments(data, failed));
      }

      //axios.post(url, reqBody).then((response) => {
      //  console.log('The Enrollment Listings are: ' + JSON.stringify(response));
      //  dispatch(getLMSEnrollments(response, failed));
      //}, (error) => {
      //  console.log("The Get Enrollment Listings Error is: " + error);
      //});
        
      if (!unmounted) {
        //setEnrollments([...enrollments, data.data.enrollments]);
        //setEnrollments(data.data.enrollments);
        setEnrollmentsLoading(false);
    }
  }

  getDoceboEnrollments();
  
  return () => {
    unmounted = true;
  };
}, []);

  const courseDetails = [
    { key: "Course", value: `${courseId} - ${courseName}` },
    { key: "Session", value: `${sessionId} - ${sessionName}` },
    { key: "Event", value: `${eventId} - ${eventName}` },
  ];

  return (
    <Container className="bg-white rounded py-3 position-relative manage-course">
      {enrollmentsLoading && (
        <div className="spinner-overlay-container">
          <div className="spinner-overlay">
            <Loader active size="big" inline="centered" inverted />
            <div className="spinner-text text-light">One Moment...</div>
          </div>
        </div>
      )}

      <ManageRosterPageHeader title="Manage Roster" />
      <CourseDetailsScrollStrip courseDetails={courseDetails} />

      <Row>
        <Col xs={3}>
          <section className="manage-course-learner-search mt-4 px-3 py-3">
            <header className="d-flex align-items-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-person-fill-add"
                viewBox="0 0 16 16"
              >
                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
              </svg>
              <h3 className="manage-course-learner-title ml-2">Learner Check-In</h3>
            </header>

            <p className="manage-course-learner-desc mb-3">
              Search by learner name or directly by ID/username.
            </p>

            <Form.Label className="field-label mb-1">First and/or last name</Form.Label>
            <FormControl
              className="mb-2"
              placeholder="First and/or last name"
              onChange={onChangeName}
              value={name}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleSearchUsers();
                }
              }}
            />
            <div className="d-flex">
              <Button variant="primary" onClick={handleSearchUsers} className="mx-auto mb-3 px-4">
                Find Learner
              </Button>
            </div>

            <div className="border-top mx-2 mb-2" />
            <div className="text-center font-weight-bold mb-2">OR</div>

            <FormControl
              placeholder="Employee ID or Username or Badge ID"
              aria-label="Employee ID or Username or Badge ID"
              aria-describedby="basic-addon2"
              onChange={onChangeUsername}
              value={username}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleShow();
                }
              }}
            />
            <div className="d-flex">
              <Button variant="primary" onClick={handleShow} className="mx-auto mt-3 px-4">
                Search
              </Button>
            </div>
          </section>
        </Col>

        <Col md={9} className="mb-4">
          <DoceboRosterTable />
        </Col>
      </Row>

      <CommonModal
        show={show}
        onHide={handleClose}
        title={<Modal.Title>Confirm User Selection</Modal.Title>}
        footer={
          <>
            <Button variant="dark" onClick={handleClose}>
              Close
            </Button>
            <Button variant="success" onClick={handleSubmit} disabled={disabled}>
              Confirm
            </Button>
          </>
        }
        modalProps={{
          size: "lg",
          centered: true,
          className: "manage-roster-modal",
          backdrop: "static",
        }}
      >
        {usersLoading ? (
          <div className="d-flex justify-content-center py-4">
            <Loader active inline="centered">
              Searching...
            </Loader>
          </div>
        ) : usersInfo.length === 0 ? (
          <UserInfoModal onSubmit={onUserInfoFormSubmit} userInfo={userInfo} />
        ) : (
          <UserInfoModal onSubmit={onUserInfoFormSubmit} userInfo={usersInfo} />
        )}
      </CommonModal>

      <ToastContainer />
    </Container>
  );
};

export default ManageRoster;